export default "__VITE_ASSET__Cnszy$EQ__"